import { INITIAL_LIVING_SPACE_RANGE } from './living-space.state';
import { immerOn } from 'ngrx-immer/store';
import {
  resetLivingSpaceFilter,
  setLivingSpaceFilter,
  setLivingSpaceFilterBasedOnUrlValues,
} from './living-space.actions';
import { resetAllFilters } from '../filter.actions';
import {
  FilterState,
  LivingSpaceFilterState,
  LivingSpaceRange,
} from '@immosky/types';

export const initialLivingSpaceState: LivingSpaceFilterState = {
  isActive: false,
  options: [],
  isDisplayed: false,
  filter: INITIAL_LIVING_SPACE_RANGE,
  default: INITIAL_LIVING_SPACE_RANGE,
};

export const livingSpaceReducers = [
  immerOn(setLivingSpaceFilter, (state: FilterState, { filter }) => {
    updateLivingSpaceFilter(state, filter);
  }),
  immerOn(resetLivingSpaceFilter, resetAllFilters, (state: FilterState) => {
    updateLivingSpaceFilter(state, state.livingSpace.default);
  }),
  immerOn(
    setLivingSpaceFilterBasedOnUrlValues,
    (state: FilterState, { values }) => {
      const options = state.livingSpace.options;
      const minOption = options.find((o) => o.value === values.min);
      const maxOption = options.find((o) => o.value === values.max);

      if (minOption) {
        state.livingSpace.filter.min = minOption;
      }

      if (maxOption) {
        state.livingSpace.filter.max = maxOption;
      }

      state.livingSpace.isActive = isLivingSpaceFilterActive(
        state.livingSpace.filter,
        state.livingSpace.default
      );
    }
  ),
];

export function updateLivingSpaceFilter(
  state: FilterState,
  filter: LivingSpaceRange
) {
  state.livingSpace.filter = filter;
  state.livingSpace.isActive = isLivingSpaceFilterActive(
    state.livingSpace.filter,
    state.livingSpace.default
  );
}

export function isLivingSpaceFilterActive(
  filter: LivingSpaceRange,
  defaultFilter: LivingSpaceRange
): boolean {
  const isMinLivingSpaceDefault = filter.min.value === defaultFilter.min.value;
  const isMaxLivingSpaceDefault = filter.max.value === defaultFilter.max.value;
  return !(isMinLivingSpaceDefault && isMaxLivingSpaceDefault);
}
